import React from "react";
import { IoMdClose } from "react-icons/io";
import {
  FaUserTie,
  FaUsers,
  FaCalendarAlt,
  FaBook,
  FaBriefcase,
  FaUsersCog,
  FaVenusMars,
} from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import parse from "html-react-parser";
import moment from "moment";

const JobDetailsModal = ({ isOpen, onClose, job }) => {
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 md:backdrop-blur-sm z-50 transition-opacity md:animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-white shadow-xl rounded-2xl p-6 md:h-auto hide-scrollbar h-[100%] overflow-y-scroll  max-w-3xl w-[90%] relative transform scale-95 hover:scale-100 transition-transform duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-red-600 transition duration-200"
          onClick={onClose}
        >
          <IoMdClose size={28} />
        </button>

        <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4">
          {job?.job_title || "Job Title"}
        </h2>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-sm text-gray-700">
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaUserTie className="size-5 text-blue-600" />
            <span>Job Type:</span> <strong>{job?.job_type || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaBriefcase className="size-5 text-indigo-600" />
            <span>Experience:</span> <strong>{job?.experience || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaUsers className="size-5 text-green-600" />
            <span>Age Limit:</span> <strong>{job?.age_limit || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaUsersCog className="size-5 text-orange-600" />
            <span>Total Seats:</span>{" "}
            <strong>{job?.total_seat || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaMapLocationDot className="size-5 text-red-600" />
            <span>Location:</span> <strong>{job?.location || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaCalendarAlt className="size-5 text-purple-600" />
            <span>Deadline:</span>{" "}
            <strong>
              {job?.deadline_date
                ? moment(job.deadline_date).format("MMM D, YYYY")
                : "N/A"}
            </strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaVenusMars className="size-5 text-pink-600" />
            <span>Gender:</span> <strong>{job?.gender || "N/A"}</strong>
          </div>
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <FaBook className="size-5 text-yellow-600" />
            <span>Education:</span> <strong>{job?.education || "N/A"}</strong>
          </div>
        </div>

        <p className="mt-4 text-gray-700 text-justify leading-relaxed h-[200px] overflow-y-scroll bg-gray-50 p-3 rounded-lg shadow-sm">
          {parse(job?.job_description || "")}
        </p>
      </div>
    </div>
  );
};

export default JobDetailsModal;
